import { z } from 'zod';
// ≥12 chars, 1 uppercase + 1 number + 1 special char
const SPECIAL_CHARS_RE = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/;
export const PasswordSchema = z
    .string()
    .min(12, 'Password must be at least 12 characters')
    .refine((p) => /[A-Z]/.test(p), 'Password must contain at least 1 uppercase letter')
    .refine((p) => /[0-9]/.test(p), 'Password must contain at least 1 number')
    .refine((p) => SPECIAL_CHARS_RE.test(p), 'Password must contain at least 1 special character');
//# sourceMappingURL=password.js.map